import { ReactNode, useMemo, useState } from 'react';
import { HeaderContext } from './HeaderContext';
import { PlanBillingNotice } from './PlanBillingNotice';

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [headerContent, setHeaderContent] = useState<ReactNode>(null);
  const [headerRightContent, setHeaderRightContent] = useState<ReactNode>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  const contextValue = useMemo(
    () => ({
      headerContent,
      setHeaderContent,
      headerRightContent,
      setHeaderRightContent,
      isLoading,
      setLoading,
    }),
    [headerContent, headerRightContent, isLoading],
  );

  return (
    <HeaderContext.Provider value={contextValue}>
      <PlanBillingNotice />
      {children}
    </HeaderContext.Provider>
  );
}
